import React from "react";
import { Notification } from "@zambezi/sdk/notification";
import "./CustomErrorScreen.css";
import {
  PAGE_NOT_FOUND__ERROR_MESSAGE,
  PAGE_NOT_FOUND__ERROR_TITLE,
} from "../../constants/Constants";
import { Footer } from "@eforms/forms-common-ui";
import { getBrandDetails } from "../../utils/getBrandDetails";

const ErrorMessage = ({ error }) => {
  const { heading, body } = window.environmentConfig.errorMessages[error];
  return (
    <div className="error-screen-wrapper">
      <div className="zb-heading1" data-testid="error-heading" id="heading-123">
        {heading}
      </div>
      <div data-testid="error-body">
        {body.map((paragraphText, index) => (
          <p
            key={`error-body-${index}`}
            className="zb-body-small"
            dangerouslySetInnerHTML={{ __html: paragraphText }}
          />
        ))}
      </div>
    </div>
  );
};

const AuthenticationErrorScreen = ({ error }) => {
  return <ErrorMessage error={error} />;
};

const SchemaErrorScreen = ({ error }) => {
  return (
    <>
      {error === "FORM_NOT_FOUND" ? (
        <div className="error-screen-wrapper" data-testid="not-found-error">
          <Notification status="error" title="Form not found!" />
        </div>
      ) : (
        <ErrorMessage error={error} />
      )}
    </>
  );
};

export const CustomErrorScreen = ({ schemaError, authenticationError }) => {
  return authenticationError ? (
    <AuthenticationErrorScreen error={authenticationError} />
  ) : schemaError ? (
    <SchemaErrorScreen error={schemaError} />
  ) : null;
};

export const ErrorScreen = () => {
  const onClick = (e) => {
    e.preventDefault();
    window.location.href = window.environmentConfig?.errorRedirectUrl || "";
  };

  const hash = window.location.hash;
  const cleanHash = hash.substring(1);
  const params = new URLSearchParams(cleanHash.replace('/',''));
  const errorCode = params.get('error')?.toUpperCase();

  const brandDetails = getBrandDetails();

  return (
    <div>
      <header className="zb-masthead-container" role="banner">
        <div className="zb-masthead preview-masterhead">
          <span
            className={brandDetails?.cssClass ? brandDetails.cssClass : null}
            role="img"
            aria-label={brandDetails?.label ? brandDetails.label : null}
          />
        </div>
      </header>
      {errorCode && window.environmentConfig?.errorMessages[errorCode] ?
        <AuthenticationErrorScreen error={errorCode} />
        :
        <div className="zb-container">
          <div className="zb-columns">
            <section className="zb-card">
              <div className="zb-card-body">
                <div className="errorMessage-header">
                  {PAGE_NOT_FOUND__ERROR_TITLE}
                </div>
                <div className="errorMessage-paragraph">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: PAGE_NOT_FOUND__ERROR_MESSAGE,
                    }}
                  ></span>
                </div>
                <button
                  type="button"
                  className="zb-button zb-button-primary redirectBtn"
                  tabIndex={0}
                  onClick={onClick}
                >
                  {window.environmentConfig?.errorRedirectButtonText ||
                    "Click here"}
                </button>
              </div>
            </section>
          </div>
        </div>
      }
      <Footer fullFooter={true} />
    </div>
  );
};
